import { Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ScrollToTop } from "./ScrollToTop";
import { Analytics } from "./Analytics";
import { EnvBadge } from "./EnvBadge";
import { ConsentBanner } from "./ConsentBanner";

const AppShell = () => (
  <TooltipProvider>
    <Analytics />
    <EnvBadge />
    <ScrollToTop />
    <Toaster />
    <Sonner />
    <ConsentBanner />
    <Outlet />
  </TooltipProvider>
);

export default AppShell;
